import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import { sliderSchema } from "../../Validation/Validation";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import CodeEditor from "../../Components/CodeEditor";
import ImageUploadDragAndDrop from "../../Components/ImageUploadDragAndDrop";
import Breadcrumb from "../../Components/Breadcrumb";
import { customStyles } from "../../utils/constant";
import Select from "react-select";

const AddBanner = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    title: editData?.title,
    badge: editData?.badge || "",
    description: editData?.description || "",
    type: editData?.type || "",
    url: editData?.url || "",
    desktopImage: editData?.desktopImage,
    mobileImage: editData?.mobileImage,
    sortOrder: editData?.sortOrder || 1,
    isActive: editData?.isActive,
  };

  const { values, errors, handleChange, handleSubmit, setFieldValue, setFieldTouched, touched } =
    useFormik({
      initialValues: initalvalues,
      validationSchema: sliderSchema,
      onSubmit: async (values) => {
        setLoading(true);
        try {
          const formData = new FormData();
          formData.append("title", values.title || "");
          formData.append("badge", values.badge || "");
          formData.append("description", values.description || "");
          formData.append("sortOrder", values.sortOrder);
          formData.append("type", values.type);
          formData.append("isActive", values.isActive || false);

          if (values.desktopImage instanceof File) {
            formData.append("desktopImage", values.desktopImage);
          }
          if (values.mobileImage instanceof File) {
            formData.append("mobileImage", values.mobileImage);
          }
          const response = editingId
            ? await axiosInstance.put(
              `/homebanner/updatehomebanner/${editingId}`,
              formData,
            )
            : await axiosInstance.post("/homebanner/createhomebanner", formData);

          if (response.status === 200) {
            toast.success(response.data.message);
            navigator("/home-banners");
          }
        } catch (error) {
          toast.error(error.response?.data?.message);
          return error;
        } finally {
          setLoading(false);
        }
      },
    });

  const Type = [
    { label: "Image", value: "image" },
    { label: "Video", value: "video" },
  ];

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Home Banners", path: "/home-banners" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Banner
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label
                        htmlFor="banner-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className="form-control border-dark "
                        id="banner-sortOrder"
                        name="sortOrder"
                        placeholder="Enter a banner sort order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-4">
                    <div className="form-group">
                      <label htmlFor="gallery-type" className="col-form-label">
                        Type
                      </label>

                      <Select
                        id="gallery-type"
                        name="type"
                        placeholder="Select Type"
                        options={Type}
                        styles={customStyles}
                        value={
                          Type.find(
                            (opt) => opt.value === values.type
                          ) || null
                        }
                        onChange={(option) => {
                          setFieldValue("type", option?.value || "");
                          setFieldValue("url", "");
                          setFieldValue("thumbnailImage", "");

                          setFieldTouched("type", true);
                        }}
                        onBlur={() => setFieldTouched("type", true)}
                      />

                      {touched.type && errors.type && (
                        <small className="text-danger">
                          {errors.type}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <label htmlFor="banner-badge" className="col-form-label ">
                        Banner Badge
                      </label>
                      <input
                        type="text"
                        className="form-control border border-dark"
                        id="banner-badge"
                        name="badge"
                        placeholder="Enter banner badge"
                        value={values.badge}
                        onChange={handleChange}
                      />
                      {touched.badge && errors.badge && (
                        <small className="text-danger">{errors.badge}</small>
                      )}
                    </div>
                  </div>

                  {/* <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="banner-name" className="col-form-label ">
                        Banner Title
                      </label>
                      <input
                        type="text"
                        className="form-control border border-dark"
                        id="banner-title"
                        name="title"
                        placeholder="Enter banner title"
                        value={values.title}
                        onChange={handleChange}
                      />
                      {touched.title && errors.title && (
                        <small className="text-danger">{errors.title}</small>
                      )}
                    </div>
                  </div> */}

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="banner-subTitle"
                        className="col-form-label "
                      >
                        Title
                      </label>
                      <CodeEditor
                        value={values.title}
                        onChange={(val) => setFieldValue("title", val)}
                        placeholder="Enter a title"
                      />
                      {touched.title && errors.title && (
                        <small className="text-danger">{errors.title}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="slider-description"
                        className="col-form-label "
                      >
                        Description
                      </label>

                      <CodeEditor
                        value={values.description}
                        onChange={(val) => setFieldValue("description", val)}
                      />

                      {touched.description && errors.description && (
                        <small className="text-danger">
                          {errors.description}
                        </small>
                      )}
                    </div>
                  </div>


                  <div className="col-sm-6">
                    <ImageUploadDragAndDrop
                      id="banner-desktopImage"
                      label={`Desktop Image (1920 X 950px)`}
                      value={values.desktopImage}
                      onChange={(file) => setFieldValue("desktopImage", file)}
                      error={errors.desktopImage}
                      touched={touched.desktopImage}
                      accept="image/*,video/mp4,video/webm,video/quicktime"
                    />
                  </div>

                  <div className="col-sm-6">
                    <ImageUploadDragAndDrop
                      id="banner-mobileImage"
                      label={`Mobile Image (600px X 900px)`}
                      value={values.mobileImage}
                      onChange={(file) => setFieldValue("mobileImage", file)}
                      error={errors.mobileImage}
                      touched={touched.mobileImage}
                      accept="image/*,video/mp4,video/webm,video/quicktime"
                    />
                  </div>

                  <div className="col-md-12 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to="/home-banners">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBanner;
